const router = function (permissions) {
  return ({
    path: 'extratoAssociado',
    component: () => import('@/views/ExtratoAssociado/ExtratoAssociadoModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        component: () => import('@/views/ExtratoAssociado/ExtratoAssociadoList.vue'),
        meta: { permissions, title: 'Consulta Extrato dos Associados' },
      },
    ],
  })
}

export default {
  router,
}
